module.exports = __webpack_public_path__ + "img/outsourcing.6ea90759.jpg";